import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=6fdeb5e8"
import script from "./Series.vue?vue&type=script&lang=ts"
export * from "./Series.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports